import request from '../../axios';

export const patchLoanRequest = async (payload: IPatchLoanRequestPayload) => {
  return await request.patch(`/api/v2/payment/loan-request`, payload);
};
